// The panel under the editor listing type-checker diagnostics. Clicking one
// jumps the editor to its source location.

import type { Diagnostic } from "../../src/frontend/checker.js";

interface DiagnosticsPanelProps {
  diagnostics: Diagnostic[];
  onSelect(line: number, col: number): void;
}

export function DiagnosticsPanel({ diagnostics, onSelect }: DiagnosticsPanelProps) {
  if (diagnostics.length === 0) {
    return (
      <div id="diagnostics">
        <span className="ok">✓ no diagnostics</span>
      </div>
    );
  }
  return (
    <div id="diagnostics">
      {diagnostics.map((d, i) => (
        <div
          key={i}
          className={`diag ${d.severity}`}
          onClick={() => onSelect(d.span.start.line, d.span.start.col)}
        >
          <span className="loc">
            {d.span.start.line}:{d.span.start.col}
          </span>{" "}
          {d.message}
        </div>
      ))}
    </div>
  );
}
